import Box from '@mui/material/Box'
import type { ProviderReward } from '../lib/types'
import { formatEstimatedDuration } from '../lib/format-estimated-duration'
import { surveyEntryStatAssets } from '../lib/surveyEntryStatAssets'
import { surveyEntryStatsGridSx } from '../styles/surveyEntryStyles'
import { SurveyEntryStatCard } from './SurveyEntryStatCard'
import { SurveyEntryStatIcon } from './SurveyEntryStatIcon'

interface SurveyEntryStatsGridProps {
  readonly questionCount: number
  readonly estimatedCompletionMinutes: number
  readonly reward: ProviderReward
}

export function SurveyEntryStatsGrid({
  questionCount,
  estimatedCompletionMinutes,
  reward,
}: SurveyEntryStatsGridProps) {
  const questionValue = String(questionCount)

  const instrumentTypeValue = reward.enabled ? 'Reward' : 'No Rewards'
  const instrumentTypeVariant = reward.enabled ? 'duration' : 'muted'

  return (
    <Box sx={surveyEntryStatsGridSx} data-testid="instrument-info-meta">
      <SurveyEntryStatCard
        label="Questions"
        value={questionValue}
        icon={
          <SurveyEntryStatIcon
            src={surveyEntryStatAssets.questionsIconUrl}
            testId="instrument-info-stat-questions-icon"
          />
        }
        testId="instrument-info-stat-questions"
      />
      <SurveyEntryStatCard
        label="Duration"
        value={formatEstimatedDuration(estimatedCompletionMinutes)}
        icon={
          <SurveyEntryStatIcon
            src={surveyEntryStatAssets.durationIconUrl}
            testId="instrument-info-stat-duration-icon"
          />
        }
        variant="duration"
        testId="instrument-info-stat-duration"
      />
      <SurveyEntryStatCard
        label="Intrument type"
        value={instrumentTypeValue}
        icon={
          <SurveyEntryStatIcon
            src={surveyEntryStatAssets.instrumentTypeIconUrl}
            testId="instrument-info-stat-instrument-type-icon"
          />
        }
        variant={instrumentTypeVariant}
        rewardIcon
        testId="instrument-info-stat-instrument-type"
      />
    </Box>
  )
}
